import { render, staticRenderFns } from "./SurrenderRequestDelNIdPop.vue?vue&type=template&id=704812e8&scoped=true"
import script from "./SurrenderRequestDelNIdPop.vue?vue&type=script&lang=js"
export * from "./SurrenderRequestDelNIdPop.vue?vue&type=script&lang=js"
import style0 from "./SurrenderRequestDelNIdPop.vue?vue&type=style&index=0&id=704812e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704812e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704812e8')) {
      api.createRecord('704812e8', component.options)
    } else {
      api.reload('704812e8', component.options)
    }
    module.hot.accept("./SurrenderRequestDelNIdPop.vue?vue&type=template&id=704812e8&scoped=true", function () {
      api.rerender('704812e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/SurrenderRequestDelNIdPop.vue"
export default component.exports